var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 12,
    viewBox: "0 0 11 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.65203 3.26953H8.81498C8.75806 3.26953 8.70449 3.29743 8.67101 3.34319L5.50025 7.71373L2.32949 3.34319C2.296 3.29743 2.24243 3.26953 2.18551 3.26953H1.34846C1.27592 3.26953 1.2335 3.35212 1.27592 3.41127L5.21118 8.8365C5.35404 9.03293 5.64645 9.03293 5.78819 8.8365L9.72346 3.41127C9.76699 3.35212 9.72458 3.26953 9.65203 3.26953Z",
    fill: "black",
    fillOpacity: 0.85
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrow);
export default __webpack_public_path__ + "static/media/downArrow.c1c062e20f4764cff8ab8fefa6569313.svg";
export { ForwardRef as ReactComponent };